import {
    ComposeMessageEditorErrorType,
    ComposeStateType,
} from "../../reducer.types";

/**
 * Returns an error if the user added a template
 * with a placeholder (i.e. *****NAME*****) and did not
 * customise it
 */
export const validatePlaceholderInMessage = ({
    messageBody,
    template,
}: {
    messageBody: string;
    template: ComposeStateType["template"];
}): Pick<ComposeMessageEditorErrorType, "placeholderRemains"> => {
    const placeholderRegex = /\*{5}(\w|\s)*\*{5}/;
    return placeholderRegex.test(messageBody) && template.type !== "NoTemplate"
        ? { placeholderRemains: "TEMPLATE_PLACEHOLDER_REMAINS" }
        : {};
};
